import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IProjectProfiles } from 'redux-store/api/projects';

export type TSidePanelContentType =
  | 'notifications_feed'
  | 'activity_feed'
  | 'selections_file_cabinet';

export interface ISidePanel {
  isOpen: boolean;
  isEditorExpanded: boolean;
  isBeforeOpened: boolean;
  isFullScreen: boolean;
  sidePanelContent: TSidePanelContentType;
  projectId: number;
  mentionedProfile: IProjectProfiles | null;
  editorKey: number;
  costCodeCabinetId: string | number | null;
}

const initialState: ISidePanel = {
  isOpen: false,
  isBeforeOpened: false,
  isEditorExpanded: true,
  isFullScreen: false,
  sidePanelContent: 'activity_feed',
  projectId: 0,
  mentionedProfile: null,
  editorKey: Math.floor(Math.random() * 100),
  costCodeCabinetId: null,
};

export const sidePanelSlice = createSlice({
  name: 'sidePanel',
  initialState,
  reducers: {
    handleOpenSidePanel: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
      if (!action.payload) {
        state.mentionedProfile = null;
      }
    },

    setFullScreen: (state) => {
      state.isFullScreen = true;
    },

    setCollapseFullScreen: (state) => {
      state.isFullScreen = false;
    },

    handleSetSidePanelContent: (state, action: PayloadAction<TSidePanelContentType>) => {
      state.sidePanelContent = action.payload;
    },

    handleSetProjectId: (state, action: PayloadAction<number>) => {
      state.projectId = action.payload;
    },

    handleEditorKeyChange: (state) => {
      state.editorKey = Math.floor(Math.random() * 100);
    },

    handleSetMentionedProfile: (state, action: PayloadAction<IProjectProfiles>) => {
      state.mentionedProfile = action.payload;
      state.editorKey = Math.floor(Math.random() * 100);
    },

    handleResetMentionedProfile: (state) => {
      state.mentionedProfile = null;
    },

    handleSetEditorExpanded: (state, action: PayloadAction<boolean>) => {
      state.isEditorExpanded = action.payload;
      if (!action.payload) {
        state.mentionedProfile = null;
      }
    },

    handleSetIsBeforeOpened: (state, action: PayloadAction<boolean>) => {
      state.isBeforeOpened = action.payload;
    },

    handleSetCabinetId: (state, action: PayloadAction<string | number | null>) => {
      state.costCodeCabinetId = action.payload;
    },

  },
});

export const {
  setFullScreen,
  handleOpenSidePanel,
  handleSetProjectId,
  setCollapseFullScreen,
  handleSetSidePanelContent,
  handleResetMentionedProfile,
  handleSetMentionedProfile,
  handleSetEditorExpanded,
  handleSetIsBeforeOpened,
  handleSetCabinetId,
  handleEditorKeyChange,
} = sidePanelSlice.actions;

export default sidePanelSlice.reducer;
